import * as React from 'react';
import '../models/adyen/payment-type.js';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import { useIsExpressPaymentMethodSupported } from './use-is-express-payment-method-supported.js';

const useIsExpressPaypalSupportedForCart = (cartId)=>{
    const [getIsPaypalSupportedForCart, { isPaymentMethodSupported , called , loading , error  }] = useIsExpressPaymentMethodSupported(PaymentMethod.PAYPAL);
    React.useEffect(()=>{
        if (cartId) {
            getIsPaypalSupportedForCart(cartId);
        }
    }, [
        getIsPaypalSupportedForCart,
        cartId
    ]);
    return {
        isExpressPaypalSupported: isPaymentMethodSupported,
        loading,
        called,
        error
    };
};

export { useIsExpressPaypalSupportedForCart };
//# sourceMappingURL=use-is-express-paypal-supported.js.map
